export default __webpack_public_path__ + "static/media/user-free.ca331e0c.svg";